import { api } from "api/api";
import { AxiosError } from "axios";
import HelpdeskTipoChamado from "model/helpdesk/HelpdeskTipoChamado";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class HelpdeskTipoChamadoService implements BaseServiceCadastros<HelpdeskTipoChamado> {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/helpdeskTipoChamado/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    consultar(id: number) {
        return new Promise<HelpdeskTipoChamado>((resolve, reject): void => {
            api
                .get(`/helpdeskTipoChamado/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(helpdeskTipoChamado: HelpdeskTipoChamado) {
        return new Promise<HelpdeskTipoChamado>((resolve, reject): void => {
            api
                .post(`/helpdeskTipoChamado/incluir`, JSON.stringify(helpdeskTipoChamado))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(helpdeskTipoChamado: HelpdeskTipoChamado) {
        return new Promise<HelpdeskTipoChamado>((resolve, reject): void => {
            api
                .put(`/helpdeskTipoChamado/editar`, JSON.stringify(helpdeskTipoChamado))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/helpdeskTipoChamado/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default HelpdeskTipoChamadoService;